/* eslint-disable no-underscore-dangle */
import Renderer from './date-renderer';
import _ from 'lodash';

const DefaultColumnComponent = require('@gluenetworks/steve_ui_widgets').GridGl
  .DefaultColumnComponent;

class DateComponent extends DefaultColumnComponent {
  constructor(value) {
    super(value);
    this._value = value;
    this._renderer = new Renderer(this);
    this._registerListeners();
  }

  get renderer() {
    return this.getRenderer();
  }

  getRenderer() {
    return this._renderer;
  }

  shutdown() {
    this._unregisterListeners();
    const prom = this._renderer._shutdown();
    this._renderer = undefined;
    this._value = undefined;
    return prom;
  }

  setValue(newVal) {
    if (!_.isUndefined(newVal)) {
      this.setDate(newVal);
    }
  }

  getValue() {
    return this.getDate();
  }

  setDate(newVal) {
    this._value = newVal;
    this.emit('Date', newVal);
    return this;
  }

  getDate() {
    return this._value;
  }
}

export default DateComponent;
